var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{style:(_vm.showMainView ? 'max-width: 940px; margin: auto;' : '')},[_c('v-content',[(_vm.showMainView)?_c('main-view',{on:{"open-test-view":function($event){_vm.showMainView = false}}}):_c('calculation-test-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }